import React from 'react';
import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { alpha, darken, lighten } from '@mui/material/styles';

import { VISHING_METHODOLOGY_PARAGRAPHS } from './vishingReportPdfHelpers';

const MethodologySection = ({ primary = '#0A68FF' }) => {
  const pDark = darken(primary, 0.35);
  const pMid = darken(primary, 0.15);
  const pLite = lighten(primary, 0.28);
  const ink = '#0f172a';

  return (
    <Box
      id="methodology"
      sx={{
        maxWidth: '8.5in',
        p: '0.72in 0.82in',
        bgcolor: '#fff',
        color: ink,
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
      }}
    >
      <Stack spacing={1.1} sx={{ mb: 1.4 }}>
        <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
          Methodology
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: alpha(ink, 0.8),
            lineHeight: 1.6,
            maxWidth: '92%',
          }}
        >
          This section explains how we normally conduct a voice-phishing assessment from campaign design and call execution through outcome analysis and reporting.
        </Typography>
      </Stack>

      <Divider
        sx={{
          mb: 2.1,
          borderColor: alpha(ink, 0.08),
          '&::after': {
            content: '""',
            display: 'block',
            height: 4,
            width: 180,
            mt: 1,
            borderRadius: 2,
            background: `linear-gradient(90deg, ${pDark}, ${pMid} 60%, ${pLite})`,
          },
          '@media print': { '&::after': { background: pMid } },
        }}
      />

      <Box
        sx={{
          mb: 1.8,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(primary, 0.045),
          border: `1px solid ${alpha(primary, 0.14)}`,
        }}
      >
        <Typography variant="body1" sx={{ color: alpha(ink, 0.86), lineHeight: 1.6 }}>
          We use a staged methodology so the assessment team can simulate realistic vishing activity, measure user susceptibility, and translate those observations into practical security guidance.
        </Typography>
      </Box>

      <Stack spacing={1.45}>
        {VISHING_METHODOLOGY_PARAGRAPHS.map((paragraph) => (
          <Typography
            key={paragraph}
            variant="body1"
            sx={{
              color: alpha(ink, 0.96),
              lineHeight: 1.65,
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
};

export default MethodologySection;
